import { space } from 'styled-system';
import styled from 'styled-components';

import { breakpoints } from '../../constants';
import { Box } from '../grid';

const HeaderContainer = styled(Box)`
  display: flex;
  @media (min-width: ${breakpoints.lg}) {
    min-height: 75px;
  }

  padding-left: 20px;
  padding-right: 20px;
  padding-top: 18px;
  padding-bottom: 18px;

  @media (min-width: ${breakpoints.lg}) {
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

const Button = styled.button`
  ${space}
  white-space: nowrap;
`;

export { Button, HeaderContainer };
